import { styled } from '@mui/system';
import {
  Checkbox,
} from '@mui/material';

export const CheckboxBase = styled(Checkbox)(() => ({
    color: 'white',
    transform: 'scale(0.7)',
    padding: '2px',
    '&.Mui-checked': {
      color: 'white',
    },
}));  